import { render, staticRenderFns } from "./DetalhamentoPedido.vue?vue&type=template&id=75cb5e8d&scoped=true"
import script from "./DetalhamentoPedido.vue?vue&type=script&lang=js"
export * from "./DetalhamentoPedido.vue?vue&type=script&lang=js"
import style0 from "./DetalhamentoPedido.vue?vue&type=style&index=0&id=75cb5e8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cb5e8d",
  null
  
)

export default component.exports